var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"test-item-audio"}},[_c('audio',{attrs:{"id":"audio","playsinline":"","controls":"","crossorigin":""}})])
}]
render._withStripped = true
export { render, staticRenderFns }